import { LocalService } from './../../../services/storage/localService';
import { Component,Injector } from '@angular/core';
import * as moment from 'moment';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import {DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { LoginService } from 'app/services/login/login.service';
import { SimuladorService } from 'app/services/operaciones/simulador/simulador.service';
import { ProformaService } from 'app/services/operaciones/proforma/proforma.service';
import { SimuladoresDetalle } from 'app/models/SimuladoresDetalle';
import { environment } from 'environments/environment';

export const MY_FORMATS  ={
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY ",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
    selector: 'app-nuevo-dnsubasta',
    templateUrl: './nuevo-dnsubasta.component.html',
    styleUrls: ['./nuevo-dnsubasta.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class NuevoDnSubastaComponent{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
    user:any;
    TEM :number = 0;

    
    varDiasMin:any;
    varDiasMax:any;
    varTasaMin:any;
    varTasaMax:any;
    IGV_Porcentaje;
    dataAdqui:any;
    dataEmpresa : any = [];
    adjuntarLogo : any;
    TEMAutomatico :number = 0;
    nroFacturas:number =0;
    MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
    simuladorDetalle : SimuladoresDetalle[]= [];
    Date = new Date();
    formTEM: FormGroup;
    datosDN : any;
    minFromDate= new Date();
    loading : boolean = false;
    PlazoMaximo = 0;
    flgTEMAutomatico :boolean = false;
    DnSubastaSave:any=[];

    ProformaTotales: any = {
      VNPP : 0,
      Adelanto :  0,
      Interes :  0,
      Comision :  0,
      IGV_TOTAL :  0,
      Desembolso :  0,
      Remanente :  0,
    };
    DnSubastaGeneral: any = {
      "idComprobante":"",
      "Num_Doc_Identificacion_Prov" : "",
      "Num_Doc_Identificacion_ADQ" : "",
      "Nivel_riesgo":"",
      "Ranking_Adquirente" : "",
      "Tasa_Tipo_de_Calculo": "",
      "Tasa_Anual": "",
      "Tasa_Mensual_Sistema": "",
      "Tasa_Mensual": "",
      "Tasa_Diaria": "",
      "Moneda": "",
      "Adelanto_porcentaje": "",
      "Fecha_Desembolso": "",
      "Fecha_Vigencia": "",
      
    }      
    documentoNegociableService:DocumentoNegociableService;
    loginService:LoginService;
    simuladoresService:SimuladorService;
    proformaService:ProformaService;
    empresaService:EmpresasService;
    localService : LocalService;
    constructor(
        private injector:Injector,
        private router:Router,
        private msgTitulos : MessagesTitles,
        private msgTitle :MessagesTitles,
        private datepipe:DatePipe
        
    ){
      this.documentoNegociableService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
      this.loginService = this.injector.get<LoginService>(LoginService);
      this.simuladoresService = this.injector.get<SimuladorService>(SimuladorService);
      this.proformaService = this.injector.get<ProformaService>(ProformaService);
      this.empresaService = this.injector.get<EmpresasService>(EmpresasService);
      this.localService = this.injector.get<LocalService>(LocalService);
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
      this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
      this.varTasaMin = this.localService.getJsonValue('ParametroTasaMinimoComercial');
      this.varTasaMax = this.localService.getJsonValue('ParametroTasaMaximo');
      this.IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
      try{
        this.datosDN = this.documentoNegociableService.datosxsubastar;
        this.ObtenerDocumentosNegociable();
        this.ObtenerRanking();
        this.obtenerEmpresa();
      }catch(error){

      }

        let now = moment();
        this.formTEM = new FormGroup({

            'Plazo' : new FormControl(''),
            'VNPP' : new FormControl(''),
            'Nivel_riesgo' : new FormControl(),
            'NombreComercialProv' : new FormControl(this.datosDN.NombreComercialProv),
            'NombreComercialAdq' : new FormControl(this.datosDN.NombreComercialAdq),
            'ProveedorScore' : new FormControl(this.datosDN.ScoringProv),
            'AdquirenteScore' : new FormControl(this.datosDN.ScoringAdq),
            'Num_Doc_Identificacion_Prov' : new FormControl(this.datosDN.Num_Doc_Identificacion_Prov),
            'Num_Doc_Identificacion_ADQ' : new FormControl(this.datosDN.Num_Doc_Identificacion_Adq),
            'ValorTipoCambio' : new FormControl(3.33),
            'TipoCambio' : new FormControl(this.datosDN.TipoCambio),
            'Moneda_Dsc' : new FormControl(this.datosDN.Moneda_Dsc),
            'Adelanto_Porcentaje' : new FormControl(85,[Validators.required,Validators.pattern('^[0-9.]+$')]),
            'Tipo_Comprobante' : new FormControl((this.datosDN.Tipo_Comprobante == 'F') ? 'Factura' : 'Recibo Honorario'),
            'Fecha_Desembolso' : new FormControl(now),
            'Ranking' : new FormControl('')          
          });
    }

    ObtenerRanking(){
      this.simuladoresService.obtenerRanking(this.datosDN.Num_Doc_Identificacion_Adq).subscribe(
        res =>{
          this.formTEM.controls['Ranking'].setValue(res);
      });
    }

    ObtenerDocumentosNegociable(){

      let Datos :any = {
        Tipo_Comprobante : '',
        idComprobante:'',
        Num_Doc_IdentificacionProv : '',
        Num_Doc_IdentificacionADQ :'',
        Moneda :0,
        Estado:''
      };
  
      Datos.Tipo_Comprobante = this.datosDN.Tipo_Comprobante;
      Datos.idComprobante = this.datosDN.idComprobante;
      Datos.Num_Doc_IdentificacionProv = this.datosDN.Num_Doc_Identificacion_Prov;
      Datos.Num_Doc_IdentificacionADQ = this.datosDN.Num_Doc_Identificacion_Adq;
      Datos.Moneda = this.datosDN.TipoMoneda;
      Datos.Estado = this.datosDN.Estado;

      this.documentoNegociableService.ObtenerDnSubasta(Datos).subscribe(
        res => {
          this.simuladorDetalle = res as SimuladoresDetalle[];
          this.elimarCalculosPorCambioFecha();
        });

    }

    diferenciaEntreDiasEnDias(a, b) {
      var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
    }

    elimarCalculosPorCambioFecha(){
      this.ProformaTotales = {
       
        VNPP : 0,
        Adelanto :  0,
        Interes :  0,
        Comision :  0,
        IGV_TOTAL :  0,
        Desembolso :  0,
        Remanente :  0,
      };
      
      this.simuladorDetalle.forEach((item,index) => {
        
       let fecha= moment(item.Fecha_de_Pago);
        item.Plazo =  this.diferenciaEntreDiasEnDias(fecha['_d'],this.formTEM.controls['Fecha_Desembolso'].value._d);
  
  
          item.Adelanto= 0;
          item.Interes = 0;
          item.Comision = 0;
          item.IGV = 0;
          item.Desembolso = 0;
          item.Remanente = 0;
  
          
      })
      this.FactoringItem();
      
    }
    guardarSubasta(){
      this.DnSubastaGeneral.Num_Doc_Identificacion_Prov = this.datosDN.Num_Doc_Identificacion_Prov;
      this.DnSubastaGeneral.Num_Doc_Identificacion_ADQ = this.datosDN.Num_Doc_Identificacion_Adq;
      this.DnSubastaGeneral.Ranking_Adquirente = this.formTEM.controls['Ranking'].value;
      this.DnSubastaGeneral.Tasa_Tipo_de_Calculo = 'M';
      this.DnSubastaGeneral.Tasa_Mensual_Sistema = this.TEMAutomatico;
      this.DnSubastaGeneral.Tasa_Mensual = this.TEM;
      this.DnSubastaGeneral.Tasa_Anual = this.TEM;
      this.DnSubastaGeneral.Tasa_Diaria = this.TEM;
      this.DnSubastaGeneral.Moneda = this.datosDN.TipoMoneda;
      this.DnSubastaGeneral.Nivel_riesgo = this.formTEM.controls['Nivel_riesgo'].value;
      this.DnSubastaGeneral.Adelanto_porcentaje = this.formTEM.controls['Adelanto_Porcentaje'].value/100;
      this.DnSubastaGeneral.Fecha_Desembolso = this.datepipe.transform(this.formTEM.controls['Fecha_Desembolso'].value,'yyyy-MM-dd');
      this.DnSubastaGeneral.idComprobante = this.datosDN.idComprobante;
      let now =  moment();
      let FVig = now.add(this.PlazoMaximo,'days');
      this.DnSubastaGeneral.Fecha_Vigencia = this.datepipe.transform(FVig,'yyyy-MM-dd');
      this.DnSubastaGeneral.Cantidad_de_Documentos_Negociables = 0;
      let actualizarDocumentos = [];
      for (let item of this.simuladorDetalle ){
        if (item.checked){
          
          if (item.Desembolso <= 0) {
            Swal.fire({
              title: `${this.msgTitulos.Error_Valor_Negativo}`,
              text:`No se Encontro Documento`,
              heightAuto: false
            })
            return;
          }
        
          actualizarDocumentos.push({"idComprobante": String(item.idComprobante),"Estado":"S"});
  
 
          this.DnSubastaGeneral.Cantidad_de_Documentos_Negociables += 1; 
                  
        }
      }

    Swal.fire({
      title: 'Espere',
      text:'Guardando información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
    this.documentoNegociableService.CrearDnSubasta(this.DnSubastaGeneral).subscribe(
      res=>{
        this.DnSubastaSave = res;
        this.actualizarDocumentosN(actualizarDocumentos);
      Swal.fire({
        title: '¡Registro exitoso!',
        type: 'success',
        allowOutsideClick:true,
        heightAuto: false
      }).then(resp =>{
        if(resp.value == true){
          this.loginService.clickGuard = true;
          this.router.navigate(["/riesgo/dnsubasta/listado"]);
        }
      });
    },err => {
      Swal.fire({
        title: this.msgTitulos.Error_Algo_Salio_Mal,
        text: err.error.error,
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
    });
      
      
    }

    actualizarDocumentosN(docs:any[]){
      for (let item of docs){
        this.documentoNegociableService.CambiarEstadoComprobante(item,item.idComprobante).subscribe(
          res => {
            this.loading = false;
          });
      }
    }
    editarTEM(){
      Swal.fire({
        title: 'Ingresar TEM',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        cancelButtonText :'Cancelar',
        confirmButtonText: 'Cambiar',
        reverseButtons:true,
        showLoaderOnConfirm: true,
        allowOutsideClick : false,
        heightAuto: false,
        }).then((result) => {
          if (result.dismiss) {
            return;
          }
          if (result.value < this.varTasaMin*100  || result.value > this.varTasaMax*100) {
            Swal.fire({
              title: `${this.msgTitulos.Error_Fuera_Rango}`,
              text:`No se encontraron datos`
            })
            return;
          }
          this.factoringAll(false,result.value/100);
        })
    }

    FactoringItem(){
      let cont_facturas =0;
      this.simuladorDetalle.forEach((item,index) => {
          if (item.checked){
            item.TEM = this.TEM;
            item.pPAdelanto  =  this.formTEM.controls['Adelanto_Porcentaje'].value/100;
            item.Moneda =   this.formTEM.controls['TipoCambio'].value;
            this.proformaService.factoring(item,1).subscribe( 
              resp => {        
                cont_facturas++;
                this.simuladorDetalle[index].Adelanto = resp['Adelanto'];
                this.simuladorDetalle[index].Remanente = resp['Remanente'];
                this.simuladorDetalle[index].Desembolso = resp['Desembolso'];
                this.simuladorDetalle[index].Comision = resp['Comision'];
                this.simuladorDetalle[index].Interes = resp['Interes'];
                this.simuladorDetalle[index].IGV = resp['IGV'];             
                this.simuladorDetalle[index]['IGV_porcentaje'] = resp['IGV_porcentaje']; 
                this.calcularTotalesImporte();
                if(this.nroFacturas == cont_facturas){
                  this.ProformaTotales.NroFacturas = this.nroFacturas;
                  this.ProformaTotales.Moneda = item.Moneda;              
                  this.proformaService.factoringResume(this.ProformaTotales,1)
                      .subscribe( resp1 => {
                          let com = resp1;
                          this.simuladorDetalle.forEach((item1,index1) => {
                            this.simuladorDetalle[index1].Comision = Math.round((this.simuladorDetalle[index1].Adelanto*com['Comision_peso'])*100)/100;
                            this.simuladorDetalle[index1].IGV = Math.round(((this.simuladorDetalle[index1].Interes+this.simuladorDetalle[index1].Comision)*this.IGV_Porcentaje)*100)/100;
                            this.simuladorDetalle[index1].Desembolso = Math.round((this.simuladorDetalle[index1].Adelanto-(this.simuladorDetalle[index1].Interes+this.simuladorDetalle[index1].Comision+this.simuladorDetalle[index1].IGV))*100)/100;
                          })
                          this.calcularTotalesImporte();
                      })
                }
              })        
          } else {
            let fecha= moment(item.Fecha_de_Pago);
              item.Plazo =  this.diferenciaEntreDiasEnDias(fecha['_d'],this.formTEM.controls['Fecha_Desembolso'].value._d);
              item.Adelanto = 0;
              item.Interes = 0;
              item.Comision = 0;
              item.IGV = 0;
              item.Desembolso = 0;
              item.Remanente= 0;
  
            this.ProformaTotales = {
                VNPP : 0,
                Adelanto :  0,
                Interes :  0,
                Comision :  0,
                IGV_TOTAL :  0,
                Desembolso :  0,
                Remanente :  0,
              };
          }
      })
    }
    factoringAll(modo : boolean, TEM){
      this.calcularPlazoMaximoSumaImporte();
      if(this.formTEM.value.VNPP>0){
        this.loading = true;
  
        this.simuladoresService.obtenerTEM(this.formTEM.value).subscribe(
          data => {
            this.TEMAutomatico = Number(data)
            if(modo){ 
              this.TEM = Number(data);
              this.flgTEMAutomatico = false;
            } else { 
              this.TEM = TEM 
              this.flgTEMAutomatico = true;
            }
              let cont_facturas = 0;
              this.simuladorDetalle.forEach((item,index) => {
                if (item.checked){
                  item.TEM = this.TEM;
                  item.pPAdelanto  =  this.formTEM.controls['Adelanto_Porcentaje'].value/100;
                  item.Moneda =  this.formTEM.controls['TipoCambio'].value;
                  this.proformaService.factoring(item,1).subscribe( 
                   resp => {
                           cont_facturas++;
                            this.simuladorDetalle[index].Adelanto = resp['Adelanto'];
                            this.simuladorDetalle[index].Remanente = resp['Remanente'];
                            this.simuladorDetalle[index].Desembolso = resp['Desembolso'];
                            this.simuladorDetalle[index].Comision = resp['Comision'];
                            this.simuladorDetalle[index].Interes = resp['Interes'];
                            this.simuladorDetalle[index].IGV = resp['IGV']; 
                            this.simuladorDetalle[index]['IGV_porcentaje'] = resp['IGV_porcentaje']; 
                            
                            this.calcularTotalesImporte();
                            if(this.nroFacturas == cont_facturas){
                              this.ProformaTotales.NroFacturas = this.nroFacturas;
                              this.ProformaTotales.Moneda = item.Moneda;              
                              this.proformaService.factoringResume(this.ProformaTotales,1)
                                  .subscribe( resp2 => {
                                      let com = resp2;
                                      this.simuladorDetalle.forEach((item2,index2) => {
                                        this.simuladorDetalle[index2].Comision = Math.round((this.simuladorDetalle[index2].Adelanto*com['Comision_peso'])*100)/100;
                                        this.simuladorDetalle[index2].IGV = Math.round(((this.simuladorDetalle[index2].Interes+this.simuladorDetalle[index2].Comision)*this.IGV_Porcentaje)*100)/100;
                                        this.simuladorDetalle[index2].Desembolso = Math.round((this.simuladorDetalle[index2].Adelanto-(this.simuladorDetalle[index2].Interes+this.simuladorDetalle[index2].Comision+this.simuladorDetalle[index2].IGV))*100)/100;
                                      })
                                      this.calcularTotalesImporte();
                                  })
                            }
                            this.loading = false;
                            })
                    
                } else {
                   let fecha= moment(item.Fecha_de_Pago);
                   item.Plazo =  this.diferenciaEntreDiasEnDias(fecha['_d'],this.formTEM.controls['Fecha_Desembolso'].value._d);
                    item.Adelanto = 0;
                    item.Interes = 0;
                    item.Comision = 0;
                    item.IGV= 0;
                    item.Desembolso = 0;
                    item.Remanente = 0;
                    
                    this.ProformaTotales = {
                      VNPP : 0,
                      Adelanto :  0,
                      Interes :  0,
                      Comision :  0,
                      IGV_TOTAL :  0,
                      Desembolso :  0,
                      Remanente :  0,
                    };
                }
              })
          });
        //-->
      } else {
        this.loading = true;
        this.simuladorDetalle.forEach((item,index) => {
                   let fecha= moment(item.Fecha_de_Pago);
                   item.Plazo =  this.diferenciaEntreDiasEnDias(fecha['_d'],this.formTEM.controls['Fecha_Desembolso'].value._d);
                    item.Adelanto = 0;
                    item.Interes = 0;
                    item.Comision = 0;
                    item.IGV = 0;
                    item.Desembolso = 0;
                    item.Remanente= 0;
                    
                    this.ProformaTotales = {
                      VNPP : 0,
                      Adelanto :  0,
                      Interes :  0,
                      Comision :  0,
                      IGV_TOTAL :  0,
                      Desembolso :  0,
                      Remanente :  0,
                    };
      })
      this.loading = false;
      }    
    }

    calcularTotalesImporte(){
      let VNPP :number = 0;
      this.simuladorDetalle.forEach((item,index) => {
      
          if (item.checked){
            
            VNPP  += Number(item.VNPP);
            this.ProformaTotales.VNPP = VNPP;
          }
      })
          let sumaVNPP :number = 0;
          let TotalAdelanto : number = 0;
          let TotalIGV : number = 0;
          let TotalInteres : number = 0;
          let TotalComision : number = 0;
          let TotalDesembolso : number = 0;
          let TotalRemanente : number = 0;
        
          for (let item of this.simuladorDetalle) {
        
            sumaVNPP += Number(item.VNPP) ; 
            TotalAdelanto += Number(item.Adelanto);
            TotalIGV += Number(item.IGV);
            TotalInteres += Number(item.Interes);
            TotalComision += Number(item.Comision);
            TotalDesembolso += Number(item.Desembolso);
            TotalRemanente += Number(item.Remanente);
        
            
          }
          this.ProformaTotales.Adelanto = TotalAdelanto;
          this.ProformaTotales.Interes = TotalInteres;
          this.ProformaTotales.Comision = TotalComision;
          this.ProformaTotales.IGV_TOTAL = TotalIGV;
          this.ProformaTotales.Desembolso = TotalDesembolso;
          this.ProformaTotales.Remanente = TotalRemanente;
    }

    calcularPlazoMaximoSumaImporte(){
      let plazo :number[] = [];
      let sumaVNPP :number = 0;
      let TotalAdelanto : number = 0;
      let TotalIGV : number = 0;
      let TotalInteres : number = 0;
      let TotalComision : number = 0;
      let TotalDesembolso : number = 0;
      let TotalRemanente : number = 0;
      this.nroFacturas = 0;
      for (let item of this.simuladorDetalle) {
        if (item.checked) { 
          this.nroFacturas++;
          plazo.push(item.Plazo);
          sumaVNPP += Number(item.VNPP) ; 
          TotalAdelanto += Number(item.Adelanto);
          TotalIGV += Number(item.IGV);
          TotalInteres += Number(item.Interes);
          TotalComision += Number(item.Comision);
          TotalDesembolso += Number(item.Desembolso);
          TotalRemanente += Number(item.Remanente);
        }
        else {
          this.TEM = 0;
        }      
      }
      let plazoMaximo = Math.max(...plazo);
      this.PlazoMaximo = plazoMaximo;
      
      this.formTEM.controls['TipoCambio'].setValue(this.datosDN.TipoMoneda);
      this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(this.datosDN.Num_Doc_Identificacion_Prov);
      this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(this.datosDN.Num_Doc_Identificacion_Adq);
      this.formTEM.controls['Plazo'].setValue(plazoMaximo);
      this.formTEM.controls['VNPP'].setValue(sumaVNPP);
      this.ProformaTotales.VNPP = sumaVNPP;
      this.ProformaTotales.Adelanto = TotalAdelanto;
      this.ProformaTotales.Interes = TotalInteres;
      this.ProformaTotales.Comision = TotalComision;
      this.ProformaTotales.IGV_TOTAL = TotalIGV;
      this.ProformaTotales.Desembolso = TotalDesembolso;
      this.ProformaTotales.Remanente = TotalRemanente;
    }

    subirLogo(){
      const logo = this.dataEmpresa && this.dataEmpresa['Logo'];
      if (logo != null && logo !== '') {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'La empresa ya cuenta con un logo registrado, contactarse con soporte.',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
      }else{
        this.adjuntarLogo = true;
      }
      
    }

    CerrarPopUpLogo(){
      this.adjuntarLogo = false;
    }

    onLogoGuardado(){
      this.adjuntarLogo = false;
      this.obtenerEmpresa();
    }

    obtenerEmpresa(){
      this.empresaService.obtenerListaAdquirentes(this.datosDN.Num_Doc_Identificacion_Adq).subscribe(
        res=>{
          this.dataEmpresa = res[0];
        }
      )
    }
    
}